const info = {
  CN: {
    detailTitle1: "产品介绍",
    detailTitle2: "AI智能算法",
    detailTitle3: "落地实施指南",
  },
  EN: {
    detailTitle1: "Product Introduction",
    detailTitle2: "AI Algorithm",
    detailTitle3: "Implementation Guidelines of Practice",
  },
};
export default info;



// WEBPACK FOOTER //
// ./src/language/home/index.js